<div class="flex w-full">
  <ng-lottie class="mx-auto w-[26.1rem] h-[26.1rem]" [options]="lottieOptions"></ng-lottie>
</div>
